import Spinner from '../../components/Spinner';
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { locomotorasService } from '../../services/api';
import api from '../../services/api';
import { Line, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend, Filler } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend, Filler);

const chartOptions = {
  responsive: true, maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: {
    x: { ticks: { color: '#888', font: { size: 10 }, maxRotation: 45, maxTicksLimit: 12 }, grid: { color: 'rgba(0,0,0,0.05)' } },
    y: { ticks: { color: '#888', font: { size: 11 } }, grid: { color: 'rgba(0,0,0,0.05)' } }
  }
};


function ServiciosTab({ servicios }) {
  const [desde, setDesde] = React.useState('');
  const [hasta, setHasta] = React.useState('');
  const [soloReales, setSoloReales] = React.useState(true);

  const filtrados = servicios
    .filter(s => {
      if (soloReales && s.descripcion === 'Importado desde Excel') return false;
      if (desde && new Date(s.fecha) < new Date(desde)) return false;
      if (hasta && new Date(s.fecha) > new Date(hasta)) return false;
      return true;
    });

  return (
    <div>
      <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: 14, marginBottom: 12, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Desde</label>
          <input type="date" value={desde} onChange={e => setDesde(e.target.value)}
            style={{ padding: '7px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Hasta</label>
          <input type="date" value={hasta} onChange={e => setHasta(e.target.value)}
            style={{ padding: '7px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input type="checkbox" id="soloReales" checked={soloReales} onChange={e => setSoloReales(e.target.checked)} />
          <label htmlFor="soloReales" style={{ fontSize: 13, color: '#555', cursor: 'pointer' }}>Solo partes reales</label>
        </div>
        <button onClick={() => { setDesde(''); setHasta(''); setSoloReales(true); }}
          style={{ padding: '7px 14px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
          Limpiar
        </button>
        <div style={{ marginLeft: 'auto', fontSize: 13, color: '#888' }}>{filtrados.length} registros</div>
      </div>

      <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f8f8f6' }}>
              <th style={{ padding: '8px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Fecha</th>
              <th style={{ padding: '8px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Maquinista</th>
              <th style={{ padding: '8px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>KM totales</th>
              <th style={{ padding: '8px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Descripcion</th>
            </tr>
          </thead>
          <tbody>
            {filtrados.length === 0 && (
              <tr><td colSpan={4} style={{ padding: 24, textAlign: 'center', color: '#aaa' }}>No hay registros</td></tr>
            )}
            {filtrados.slice(0, 100).map(s => (
              <tr key={s.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                <td style={{ padding: '8px 14px' }}>{new Date(s.fecha).toLocaleDateString('es-ES')}</td>
                <td style={{ padding: '8px 14px' }}>{s.maquinista || '—'}</td>
                <td style={{ padding: '8px 14px', fontWeight: 500 }}>{s.km_totales ? `${Math.round(s.km_totales)} km` : '—'}</td>
                <td style={{ padding: '8px 14px', color: '#888', fontSize: 12 }}>{s.descripcion || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function LocomotoraDet() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loco, setLoco] = useState(null);
  const [tab, setTab] = useState('resumen');
  const [servicios, setServicios] = useState([]);
  const [adblue, setAdblue] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unidadAdblue, setUnidadAdblue] = useState('1000');
  const [unidadComb, setUnidadComb] = useState('1000');

  useEffect(() => {
    Promise.all([
      locomotorasService.getAll(),
      api.get(`/servicios/?locomotora_id=${id}`),
      api.get(`/adblue/?locomotora_id=${id}`)
    ]).then(([locos, servs, adb]) => {
      const l = locos.data.find(l => l.id === parseInt(id));
      setLoco(l);
      setServicios(servs.data);
      setAdblue(adb.data);
    }).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <Spinner />;
  if (!loco) return <div style={{ padding: 40, color: '#888' }}>Locomotora no encontrada</div>;

  const tabs = [
    { key: 'resumen', label: 'Resumen' },
    { key: 'adblue', label: 'AdBlue' },
    { key: 'combustible', label: 'Combustible' },
    { key: 'servicios', label: 'Servicios' },
  ];

  const adblueReales = adblue.filter(r => r.es_repostaje || r.es_correccion).slice(-60);
  const adblueChart = {
    labels: adblueReales.map(r => new Date(r.fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' })),
    datasets: [{
      label: 'Litros AdBlue',
      data: adblueReales.map(r => r.litros),
      borderColor: '#378ADD',
      backgroundColor: 'rgba(55,138,221,0.1)',
      borderWidth: 2, pointRadius: 3, fill: true, tension: 0.3
    }]
  };

  const serviciosChart = {
    labels: servicios.slice(-30).map(s => new Date(s.fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' })),
    datasets: [{
      label: 'KM realizados',
      data: servicios.slice(-30).map(s => s.km_totales || 0),
      backgroundColor: '#639922', borderRadius: 4
    }]
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <button onClick={() => navigate('/staff/flota')} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 14 }}>←</button>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>🚂 {loco.numero}</h2>
          <p style={{ fontSize: 13, color: '#888', margin: '2px 0 0' }}>
            {loco.uic} · {loco.modelo} · {loco.tipo} · {loco.servicio_asignado ? loco.servicio_asignado.codigo : 'Sin servicio'}
          </p>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 20, borderBottom: '1px solid #e5e5e5', paddingBottom: 0 }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding: '10px 16px', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 14,
            fontWeight: tab === t.key ? 600 : 400,
            color: tab === t.key ? '#1a1a1a' : '#888',
            borderBottom: tab === t.key ? '2px solid #1a1a1a' : '2px solid transparent',
            marginBottom: -1
          }}>{t.label}</button>
        ))}
      </div>

      {tab === 'resumen' && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 12, marginBottom: 20 }}>
            {[
              { label: 'KM actuales', value: `${(loco.km_actuales || 0).toLocaleString('es-ES')} km`, color: '#333' },
              { label: 'Horas motor', value: `${(loco.horas_motor || 0).toFixed(0)} h`, color: '#333' },
              { label: 'Combustible', value: `${(loco.litros_combustible || 0).toFixed(0)} L`, color: (loco.litros_combustible / loco.capacidad_combustible) < 0.2 ? '#a32d2d' : '#3b6d11' },
              { label: 'AdBlue', value: `${(loco.litros_adblue || 0).toFixed(0)} L`, color: loco.litros_adblue < 105 ? '#a32d2d' : '#378ADD' },
              { label: 'Capacidad comb.', value: `${(loco.capacidad_combustible || 0).toLocaleString('es-ES')} L`, color: '#555' },
              { label: 'Capacidad AdBlue', value: `${(loco.capacidad_adblue || 0)} L`, color: '#555' },
            ].map(item => (
              <div key={item.label} style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: '14px 16px' }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>{item.label}</div>
                <div style={{ fontSize: 20, fontWeight: 600, color: item.color }}>{item.value}</div>
              </div>
            ))}
          </div>

          <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: 16, marginBottom: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 12 }}>KM por dia (ultimos 30 servicios)</div>
            <div style={{ height: 200 }}>
              <Bar data={serviciosChart} options={chartOptions} />
            </div>
          </div>

          <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>Datos generales</div>
            <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
              <tbody>
                {[
                  ['Numero', loco.numero],
                  ['UIC', loco.uic],
                  ['Modelo', loco.modelo],
                  ['Tipo', loco.tipo],
                  ['Servicio asignado', loco.servicio_asignado?.nombre || '—'],
                  ['Servicio desde', loco.servicio_desde || '—'],
                  ['Ubicacion', loco.ubicacion || '—'],
                  ['AdBlue', loco.tiene_adblue ? 'Sí' : 'No'],
                ].map(([k, v]) => (
                  <tr key={k} style={{ borderTop: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '8px 0', color: '#888', width: '40%' }}>{k}</td>
                    <td style={{ padding: '8px 0', fontWeight: 500 }}>{v}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === 'adblue' && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 16 }}>
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: '14px 16px' }}>
              <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Nivel actual</div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                <div style={{ fontSize: 20, fontWeight: 600, color: (loco.litros_adblue||0) < 105 ? '#a32d2d' : '#378ADD' }}>{(loco.litros_adblue || 0).toFixed(0)} L</div>
                <div style={{ fontSize: 13, color: '#888' }}>{Math.round(((loco.litros_adblue||0)/(loco.capacidad_adblue||530))*100)}%</div>
              </div>
            </div>
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: '14px 16px' }}>
              <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Alerta &lt;105L el</div>
              <div style={{ fontSize: 16, fontWeight: 600, color: (loco.litros_adblue||0) < 105 ? '#a32d2d' : '#333' }}>
                {(() => {
                  const litros = loco.litros_adblue || 0;
                  if (litros < 105) return 'CRITICO';
                  const kmDia = loco.servicio_asignado?.km_aproximados || 300;
                  const litrosDia = kmDia * (loco.consumo_estimado_lkm || 0.058);
                  const dias = Math.round((litros - 105) / litrosDia);
                  const fecha = new Date(); fecha.setDate(fecha.getDate() + dias);
                  return fecha.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' });
                })()}
              </div>
            </div>
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: '14px 16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <div style={{ fontSize: 12, color: '#888' }}>Consumo est.</div>
                <select value={unidadAdblue} onChange={e => setUnidadAdblue(e.target.value)}
                  style={{ fontSize: 10, border: '1px solid #ddd', borderRadius: 4, padding: '2px 4px', color: '#555' }}>
                  <option value="1">L/km</option>
                  <option value="100">L/100km</option>
                  <option value="1000">L/1000km</option>
                </select>
              </div>
              <div style={{ fontSize: 20, fontWeight: 600 }}>
                {((loco.consumo_estimado_lkm || 0.058) * parseFloat(unidadAdblue)).toFixed(unidadAdblue === '1' ? 4 : unidadAdblue === '100' ? 2 : 1)} L/{unidadAdblue}km
              </div>
            </div>
          </div>

          {(() => {
            const ALERTA = 105;
            const kmDia = loco.servicio_asignado?.km_aproximados || 300;
            const consumo = loco.consumo_estimado_lkm || 0.058;
            const litrosDia = kmDia * consumo;
            const litros = loco.litros_adblue || 0;
            const diasAlerta = litros > ALERTA ? Math.round((litros - ALERTA) / litrosDia) : 0;
            const pred = Array.from({ length: 15 }, (_, i) => {
              const fecha = new Date(); fecha.setDate(fecha.getDate() + i + 1);
              return { fecha: fecha.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' }), litros: Math.max(0, litros - litrosDia * (i + 1)) };
            });
            const predChart = {
              labels: pred.map(p => p.fecha),
              datasets: [
                { type: 'bar', label: 'Litros estimados', data: pred.map(p => p.litros), backgroundColor: pred.map(p => p.litros < ALERTA ? '#e24b4a' : p.litros < 200 ? '#ef9f27' : '#639922'), borderRadius: 4 },
                { type: 'line', label: 'Umbral alerta', data: Array(15).fill(ALERTA), borderColor: '#ef9f27', borderDash: [4,4], borderWidth: 1.5, pointRadius: 0 }
              ]
            };
            return (
              <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: 16, marginBottom: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div style={{ fontSize: 13, fontWeight: 500 }}>Prediccion 15 dias</div>
                  <span style={{ fontSize: 12, color: litros < ALERTA ? '#a32d2d' : diasAlerta < 7 ? '#854f0b' : '#3b6d11', fontWeight: 500 }}>
                    {litros < ALERTA ? 'CRITICO' : `Alerta en ${diasAlerta} dias`}
                  </span>
                </div>
                <div style={{ height: 180 }}><Bar data={predChart} options={chartOptions} /></div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 4, marginTop: 12 }}>
                  {pred.slice(0, 10).map((p, i) => (
                    <div key={i} style={{ background: p.litros < ALERTA ? '#fcebeb' : p.litros < 200 ? '#faeeda' : '#f8f8f6', borderRadius: 6, padding: '5px 6px', fontSize: 10, textAlign: 'center' }}>
                      <div style={{ color: '#888' }}>{p.fecha}</div>
                      <div style={{ fontWeight: 500, color: p.litros < ALERTA ? '#a32d2d' : p.litros < 200 ? '#854f0b' : '#333' }}>{p.litros.toFixed(0)}L</div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}

          {adblueReales.length > 0 && (
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: 16, marginBottom: 16 }}>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 12 }}>Historial AdBlue</div>
              <div style={{ height: 220 }}><Line data={adblueChart} options={chartOptions} /></div>
            </div>
          )}

          <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
            <div style={{ padding: '12px 16px', borderBottom: '1px solid #e5e5e5', fontSize: 13, fontWeight: 500 }}>Registros reales</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f8f8f6' }}>
                  <th style={{ padding: '8px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Fecha</th>
                  <th style={{ padding: '8px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Litros</th>
                  <th style={{ padding: '8px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Tipo</th>
                  <th style={{ padding: '8px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>KM</th>
                </tr>
              </thead>
              <tbody>
                {adblue.filter(r => r.es_repostaje || r.es_correccion).slice().reverse().slice(0, 20).map(r => (
                  <tr key={r.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '8px 14px' }}>{new Date(r.fecha).toLocaleDateString('es-ES')}</td>
                    <td style={{ padding: '8px 14px', fontWeight: 500 }}>{r.litros} L</td>
                    <td style={{ padding: '8px 14px' }}>
                      <span style={{ background: r.es_repostaje ? '#eaf3de' : '#f0f0f0', color: r.es_repostaje ? '#3b6d11' : '#555', borderRadius: 20, padding: '2px 8px', fontSize: 11 }}>
                        {r.es_repostaje ? 'Repostaje' : 'Correccion'}
                      </span>
                    </td>
                    <td style={{ padding: '8px 14px', color: '#888' }}>{r.km?.toLocaleString('es-ES')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === 'combustible' && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 16 }}>
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: '14px 16px' }}>
              <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Nivel actual</div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                <div style={{ fontSize: 20, fontWeight: 600, color: ((loco.litros_combustible||0)/(loco.capacidad_combustible||5000)) < 0.2 ? '#a32d2d' : '#639922' }}>{(loco.litros_combustible || 0).toFixed(0)} L</div>
                <div style={{ fontSize: 13, color: '#888' }}>{Math.round(((loco.litros_combustible||0)/(loco.capacidad_combustible||5000))*100)}%</div>
              </div>
            </div>
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: '14px 16px' }}>
              <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Alerta &lt;1500L el</div>
              <div style={{ fontSize: 16, fontWeight: 600, color: (loco.litros_combustible||0) < 1500 ? '#a32d2d' : '#333' }}>
                {(() => {
                  const litros = loco.litros_combustible || 0;
                  if (litros < 1500) return 'BAJO';
                  const kmDia = loco.servicio_asignado?.km_aproximados || 300;
                  const litrosDia = kmDia * (loco.consumo_diesel_lkm || 1.13);
                  const dias = Math.round((litros - 1500) / litrosDia);
                  const fecha = new Date(); fecha.setDate(fecha.getDate() + dias);
                  return fecha.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' });
                })()}
              </div>
            </div>
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: '14px 16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <div style={{ fontSize: 12, color: '#888' }}>Consumo est.</div>
                <select value={unidadComb} onChange={e => setUnidadComb(e.target.value)}
                  style={{ fontSize: 10, border: '1px solid #ddd', borderRadius: 4, padding: '2px 4px', color: '#555' }}>
                  <option value="1">L/km</option>
                  <option value="100">L/100km</option>
                  <option value="1000">L/1000km</option>
                </select>
              </div>
              <div style={{ fontSize: 20, fontWeight: 600 }}>
                {((loco.consumo_diesel_lkm || 1.13) * parseFloat(unidadComb)).toFixed(unidadComb === '1' ? 3 : unidadComb === '100' ? 1 : 0)} L/{unidadComb}km
              </div>
            </div>
          </div>

          {(() => {
            const cap = loco.capacidad_combustible || 5000;
            const litros = loco.litros_combustible || 0;
            const kmDia = loco.servicio_asignado?.km_aproximados || 300;
            const litrosDia = kmDia * (loco.consumo_diesel_lkm || 1.13);
            const diasRestantes = litros / litrosDia;
            const alertaPct = 0.2;
            const pred = Array.from({ length: 15 }, (_, i) => {
              const fecha = new Date(); fecha.setDate(fecha.getDate() + i + 1);
              return { fecha: fecha.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' }), litros: Math.max(0, litros - litrosDia * (i + 1)) };
            });
            const predChart = {
              labels: pred.map(p => p.fecha),
              datasets: [
                { type: 'bar', label: 'Litros estimados', data: pred.map(p => p.litros), backgroundColor: pred.map(p => (p.litros/cap) < alertaPct ? '#e24b4a' : (p.litros/cap) < 0.4 ? '#ef9f27' : '#639922'), borderRadius: 4 },
                { type: 'line', label: 'Umbral 20%', data: Array(15).fill(cap * alertaPct), borderColor: '#ef9f27', borderDash: [4,4], borderWidth: 1.5, pointRadius: 0 }
              ]
            };
            const optsComb = { ...chartOptions, scales: { ...chartOptions.scales, y: { ...chartOptions.scales?.y, min: 0, max: cap } } };
            return (
              <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: 16, marginBottom: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div style={{ fontSize: 13, fontWeight: 500 }}>Prediccion 15 dias</div>
                  <span style={{ fontSize: 12, color: (litros/cap) < alertaPct ? '#a32d2d' : '#3b6d11', fontWeight: 500 }}>
                    Agota en ~{Math.round(diasRestantes)} dias
                  </span>
                </div>
                <div style={{ height: 180 }}><Bar data={predChart} options={optsComb} /></div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 4, marginTop: 12 }}>
                  {pred.slice(0, 10).map((p, i) => {
                    const pct = (p.litros/cap)*100;
                    return (
                      <div key={i} style={{ background: pct < 20 ? '#fcebeb' : pct < 40 ? '#faeeda' : '#f8f8f6', borderRadius: 6, padding: '5px 6px', fontSize: 10, textAlign: 'center' }}>
                        <div style={{ color: '#888' }}>{p.fecha}</div>
                        <div style={{ fontWeight: 500, color: pct < 20 ? '#a32d2d' : pct < 40 ? '#854f0b' : '#333' }}>{p.litros.toFixed(0)}L</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })()}
        </div>
      )}

      {tab === 'servicios' && (
        <ServiciosTab servicios={servicios} />
      )}
    </div>
  );
}
